import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';

const SECURITY_BADGES = [
  { src: 'assets/images/bank-security/aws.png', alt: 'AWS Security', label: 'AWS' },
  { src: 'assets/images/bank-security/comodo.png', alt: 'Comodo Secured', label: 'Comodo' },
  { src: 'assets/images/bank-security/illion.png', alt: 'Illion Open Data Solutions', label: 'Illion' },
];

export const SecurityBadges = () => (
  <div className="bank-scraping__security">
    <div className="bank-scraping__security-text">
      <FormattedHTMLMessage id="bank.statement.security.info" />
    </div>
    <div className="bank-scraping__security-badges" role="group" aria-label="Security badges">
      {SECURITY_BADGES.map((badge) => (
        <img
          key={badge.label}
          src={`${BASE_PATH}${badge.src}`}
          alt={badge.alt}
          loading="lazy"
          aria-label={badge.alt}
        />
      ))}
    </div>
  </div>
);
